import React, { useRef, useState } from "react";
import CardBasic from "../CardBasic";
import ModalBasic from "../ModalBasic";
import ButtonRequire from "../Button/ButtonRequire";
import { toPng } from "html-to-image";
import axios from "axios";
import { HEADER } from "../../utils/Utils";
import FormData from "form-data";
import Button from "../Button/Button";
import { requestAuthPatch } from "../../api/authInstance";

function CardQR({
  data,
  enActionEdit,
  enActionDelete,
  editFunction,
  deleteFunction,
  isDisable,
}) {
  const [showModal, setShowModal] = useState(false);
  const elementRef = useRef(null);

  const htmlToImageConvert = () => {
    toPng(elementRef.current, { cacheBust: false })
      .then(async (dataUrl) => {
        const link = document.createElement("a");
        link.download = `${data.userOutlet?.userName}-${data.chatQuestionTrigger?.alias.replace(
          "#",
          "",
        )}*${data.userOutlet?.outlet?.name}.png`;

        let isSafari = false;
        const userAgent = navigator.userAgent.toLowerCase();
        if (userAgent.includes("chrome")) {
          console.log("Google Chrome");
          // Your Google Chrome-specific logic here
        } else if (userAgent.includes("firefox")) {
          console.log("Mozilla Firefox");
          // Your Firefox-specific logic here
        } else if (userAgent.includes("safari")) {
          console.log("Apple Safari");
          isSafari = true;
          // Your Safari-specific logic here
        } else if (userAgent.includes("edge")) {
          console.log("Microsoft Edge");
          // Your Edge-specific logic here
        } else if (userAgent.includes("opera") || userAgent.includes("opr")) {
          console.log("Opera");
          // Your Opera-specific logic here
        } else {
          console.log("Unknown browser");
          // Handle other browsers here
        }
        if (!data.arAsset) {
          // Split the base64 string to get the data part
          var dataPart = dataUrl.split(",")[1];

          // Decode the base64 data
          var decodedData = atob(dataPart);

          // Convert the decoded data to a Uint8Array
          var dataArray = new Uint8Array(decodedData.length);
          for (var i = 0; i < decodedData.length; i++) {
            dataArray[i] = decodedData.charCodeAt(i);
          }

          // Create a Blob from the Uint8Array
          var blob = new Blob([dataArray], { type: "image/png" });

          // Create a FormData object and append the Blob to it
          var formData = new FormData();
          formData.append(
            "file",
            blob,
            `${data.userOutlet?.userName}-${data.chatQuestionTrigger?.alias.replace(
              "#",
              "",
            )}*${data.userOutlet?.outlet?.name}.png`,
          );
          const HEADER_ASSETS = {
            // ...formData.getHeaders(),
            "X-Kartini-Signature": "a2FydGluaUAyMDIy",
            "Content-Type": "multipart/form-data",
          };
          let linkQR = await axios
            .post("https://asset.dashboard-kar-tini.com", formData, {
              headers: HEADER_ASSETS,
            })
            .then((res) => {
              // if success return link image\
              return `https://asset.dashboard-kar-tini.com/${res.data.data.id}`;
            })
            .catch((error) => {
              console.error("error", error);
              // return empty string
              return "";
            });

          await requestAuthPatch(`dynamic-link/${data.id}`, {
            ...data,
            qrAsset: linkQR,
          });
          data.qrAsset = linkQR;
        }
        // downloadImage(data.qr_asset, link.download);
        // Example usage
        // console.log("data");
        // var imageUrl =
        //   "https://generator.dashboard-kar-tini.com/qr/aHR0cHM6Ly93YS5tZS82MjgxMTEyNjAwNzAwP3RleHQ9JTIzS0FMQkVSRVRBSUxQQkYyMDI0VjEqNDgqNzU1NA==?base64=1";
        // var customFileName = "custom_filename.png";
        // downloadImage(data.qr_asset, customFileName);
        if (isSafari) {
          downloadImage(data.dynamic_link_qr, link.download);
        } else {
          link.href = dataUrl;
          link.click();
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const downloadImage = async (imageUrl, imageName) => {
    try {
      const response = await fetch(imageUrl, { method: "HEAD" });
      const contentType = response.headers.get("Content-Type");

      // Extract file extension from Content-Type
      const fileExtension = contentType.split("/")[1];

      // Fetch the image data
      const imageBlob = await fetch(imageUrl).then((res) => res.blob());

      // Create a download link
      const url = window.URL.createObjectURL(new Blob([imageBlob]));
      const link = document.createElement("a");
      link.href = url;
      // Set the Content-Type header to force the browser to treat the file as an image
      if (fileExtension === "octet-stream") {
        // link.href = imageUrl
        link.setAttribute(
          "download",
          `${imageName}.png` || `downloaded_image.${fileExtension}`,
        );
        link.setAttribute("type", contentType);
      } else {
        link.setAttribute(
          "download",
          `${imageName}.${fileExtension}` ||
            `downloaded_image.${fileExtension}`,
        );
        link.setAttribute("type", contentType);
      }

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading image:", error);
    }
  };

  const UserName = (data) => {
    if (data.userOutlet?.userName) {
      return data.userOutlet?.userName;
    } else if (data.userOutlet?.user?.profile) {
      return `${data.userOutlet?.user?.profile?.firstName} ${data.userOutlet?.user?.profile?.lastName}`;
    } else {
      return "-";
    }
  };

  return (
    <CardBasic
      key={data.id}
      i={data.id}
      title={UserName(data)}
      isDisable={isDisable}
      enActionDelete={enActionDelete}
      enActionEdit={enActionEdit}
      editFunction={editFunction}
      deleteFunction={deleteFunction}
      data={data}
    >
      <ModalBasic
        name="add_outlet_modal"
        open={showModal}
        setOpen={setShowModal}
        title="QR Code"
        enClose={true}
      >
        <div className="px-2 pb-2 pt-1">
          <div className="space-y-3">
            <div ref={elementRef}>
              <img
                className="w-full object-cover object-center"
                src={data.dynamicLinkQr ?? ""}
                alt="qr"
                onClick={() => {
                  setShowModal(true);
                }}
              />
              <div className="flex w-full justify-around space-x-2 divide-x divide-gray-600 bg-slate-200 text-xs">
                <div>{UserName(data)}</div>
                {/* <div>|</div> */}
                <div className="break-all px-2">{data.identifier}</div>
              </div>
              <div className="truncate bg-slate-100 text-center text-xs">
                {data.project_name}
              </div>
            </div>
            <Button
              label="Download QR"
              onClick={() => downloadImage(data.dynamicLinkQr, "test")}
              disabled={false}
              fullWidth
            />
          </div>
        </div>
      </ModalBasic>
      <div className="px-3 py-4">
        <div className="space-y-3">
          <div className="flex items-center space-x-2">
            <div className="grid grid-cols-6 gap-2">
              <div className="grid-cols-1 items-center text-xs">
                <div>
                  <img
                    className="max-h-24 w-full object-cover object-center hover:opacity-60"
                    src={data.dynamicLinkQr ?? ""}
                    alt="qr"
                    onClick={() => {
                      setShowModal(true);
                    }}
                  />
                </div>
              </div>
              <div className="col-span-5 flex flex-col space-y-2 text-xs">
                <div className="flex items-center text-xs">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className="min-h-4 min-w-4 max-w-4 text-[#ED64BD]"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M17.982 18.725A7.488 7.488 0 0 0 12 15.75a7.488 7.488 0 0 0-5.982 2.975m11.963 0a9 9 0 1 0-11.963 0m11.963 0A8.966 8.966 0 0 1 12 21a8.966 8.966 0 0 1-5.982-2.275M15 9.75a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
                    />
                  </svg>
                  <p className="ml-2 text-gray-500">{UserName(data)}</p>
                </div>
                <div className="flex w-full items-center text-xs">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="min-h-4 min-w-4 max-w-4 text-[#ED64BD]"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M16 12a4 4 0 10-8 0 4 4 0 008 0zm0 0v1.5a2.5 2.5 0 005 0V12a9 9 0 10-9 9m4.5-1.206a8.959 8.959 0 01-4.5 1.207"
                    />
                  </svg>
                  <p className="ml-2 truncate text-2xs text-gray-500">
                    {data.project?.alias ?? data.project?.name ?? "-"}
                  </p>
                </div>
                <div className="flex w-full items-center text-xs">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className="min-h-4 min-w-4 max-w-4 text-[#ED64BD]"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M5.25 8.25h15m-16.5 7.5h15m-1.8-13.5-3.9 19.5m-2.1-19.5-3.9 19.5"
                    />
                  </svg>

                  <p className="ml-2 break-all text-2xs text-gray-500">
                    {data.identifier}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </CardBasic>
  );
}

export default CardQR;
